import * as React from 'react'
import { connect } from 'react-redux'

import FormDropdown, { FormStyles } from 'embed/components/FormDropdown'
import { MultiProductState } from 'embed/reducers'
import { loadingSelector } from 'embed/selectors/loading'
import { DEPOSITS_PRODUCT_TYPES_LIST, DropdownItem } from 'embed/constants'
import { DepositProductTypesOptions, Filter, Product } from 'even-ts-static'

export interface Props {
  containerClass?: string
  dropdownStartingValue?: string
  items?: DropdownItem<DepositProductTypesOptions>[]
  loading?: boolean
  onChange?: (fieldName: string, value: string, isValid: boolean, userInitiated?: boolean) => void
  selectedItem?: DropdownItem<string>
  startingValue?: string
  styles: FormStyles
}

const DepositsProductTypeView: React.FC<Props> = ({
  containerClass,
  dropdownStartingValue = '',
  items,
  loading,
  onChange,
  selectedItem,
  styles,
}) => {
  React.useEffect(() => {
    onChange?.(
      Filter.ProductSubType,
      selectedItem ? selectedItem.value : dropdownStartingValue,
      true,
      selectedItem ? true : false,
    )
  }, [])

  const dropdownItems = items ?? DEPOSITS_PRODUCT_TYPES_LIST

  return (
    <FormDropdown
      containerClass={containerClass}
      fieldName={Filter.ProductSubType}
      isDisabled={loading}
      items={dropdownItems}
      // Re-init the FormDropdown if startingValue changes (so the correct default is rendered)
      key={selectedItem ? selectedItem.value : ''}
      label="Product Type"
      onChange={onChange}
      startingValue={dropdownStartingValue}
      styles={styles}
      currentValue={selectedItem}
    />
  )
}

const mapStateToProps = (state: MultiProductState, ownProps: Props) => {
  const items = DEPOSITS_PRODUCT_TYPES_LIST

  const dropdownStartingValue = ownProps.startingValue || items[0].value

  const selectedValue = state.filters?.[Product.Deposits]?.[Filter.ProductSubType]
  const selectedItem = items.find((el) => el.value === selectedValue)

  return {
    dropdownStartingValue,
    items,
    loading: loadingSelector(state, Product.Deposits),
    selectedItem,
  }
}

export const DepositsProductType = connect(mapStateToProps)(DepositsProductTypeView)
